<template>
    <div class="echart-box">
        <v-chart
            :options="option"
            ref="my"
            autoresize
        />
    </div>
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/component/legend";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/polar";
import "zrender/lib/svg/svg";
export default {
  name: "char1",
  components: {
    "v-chart": ECharts
  },
  props: {
    data: Object,
    datelist:{
            type:Array,
            default:()=>{
              return []
            }
        }
  },
  data() {
    return {
      option: {},
      viewdata:{},
      viewdate:[]
    };
  },
  watch:{
        datelist:{
            handler(){  
                          
              this.dataInit();
              this.init()
            },
            deep:false
        }
    },
  methods: {
    dataInit(){              
           
            this.viewdata.data1= this.data.substandard.slice(0,5); 
            this.viewdata.data2= this.data.return.slice(0,5); 
            this.viewdate=this.datelist.slice(0,5);    

           this.doit()
        },
    init() {
      this.option = {
        grid: {
          top: "10%",
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true
        },
        legend: {
          bottom: "2%",
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            color: "#fff"
          },
          icon: "rect",
          data: ["退货数", "次品数"]
        },
        tooltip: {
          formatter: function(params, index) {
            var result = params[0].name + "</br>";
            params.forEach(function(item) {
              if (item.seriesId == "a1") {
                result += item.seriesName + ":" + item.data + "</br>";
              } else if (item.seriesId == "a2") {
                //活跃会员数
                result += item.seriesName + ":" + item.data + "%</br>";
              } else if (item.seriesId == "a3") {
                //活跃会员数
                result += item.seriesName + ":" + item.data + "%</br>";
              } else {
                result += item.seriesName + ":" + item.data + "</br>";
              }
            });
            return result;
          },
          textStyle: {
            fontSize: 14
          },
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(246, 232, 87,0)" // 0% 处的颜色
                  },
                  {
                    offset: 0,
                    color: "rgba(234, 205, 44,0.4)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        },
        xAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: "#323645",
              type: "solid",
              width: 1
            },
            minInterval: 0
          },
          axisLabel: {
            color: "#fff"
          },
          type: "value"
        },

        series: [
          {
            name: "次品数",
            type: "bar",
            stack: "总量",
            itemStyle: {
              normal: {
                color: "#6648FF",
                // barWidth:10
              }
            },
            data: this.viewdata.data1,
            barWidth:this.barWidth 
          },
          {
            name: "退货数",
            type: "bar",
            stack: "总量",
           
            itemStyle: {
              normal: {
                color: "#5E2BBC",
              }
            },
            data: this.viewdata.data2
          }
        ],

        yAxis: {
          axisLabel: {
            color: "#fff"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#323645",
              type: "dashed",
              width: 1
            },
            minInterval: 0
          },
          data: this.viewdate,
          type: "category"
        }
      };
       setTimeout(()=>{
                this.$nextTick(()=>{
                    this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 2                     
                    })
                })
            },500)
      // this.doit()
    },
     
    //滚动动画
        doit(){    
            setTimeout(()=>{             
                this.runData()
            },3000)
        },
        //滚动展示数据计算
        runData(){                 
            this.data.substandard.push(this.data.substandard.shift());
            this.data.return.push(this.data.return.shift());
            this.datelist.push(this.datelist.shift());      
        },  
  },
  mounted() {
    // this.init();
  }
};
</script>